import { CartStore } from '@src/infrastructure/storage/cartStore';

export class CartViewModel {
    private cartStore: CartStore;


    luminexCount = ko.observable(0);
    blazeCount = ko.observable(0);


    constructor() {
        this.cartStore = new CartStore()
    }

    private async resetUiWithCartState() {
        const cartState = await this.cartStore.get();
        const luminexes = cartState.cartItems.find(i => i.item === 'luminex');
        this.luminexCount(luminexes.amount);
        const blazes = cartState.cartItems.find(i => i.item === 'blaze');
        this.blazeCount(blazes.amount);
    }

    removeLuminex = async () => {
        if (this.luminexCount() === 0) {
            return;
        }
        this.luminexCount(this.luminexCount() - 1);
        const cartState = await this.cartStore.get();
    }
}